import iPad from '../assets/ipad-mini-x4.webp';

const IPad = () => {
  return (
    <div>
      <img
        src={iPad}
        className="ipad absolute bottom-9 left-[112px] z-30 transition-all duration-700 ease-in-out will-change-transform"
        alt="IPad device"
        width="50px"
        height="50px"
        style={{ backfaceVisibility: 'hidden' }}
      />
    </div>
  );
};

export default IPad;
